import { render, staticRenderFns } from "./Alarm_device.vue?vue&type=template&id=7235f4fa&"
import script from "./Alarm_device.vue?vue&type=script&lang=js&"
export * from "./Alarm_device.vue?vue&type=script&lang=js&"
import style0 from "./Alarm_device.vue?vue&type=style&index=0&id=7235f4fa&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports